module.exports = __webpack_public_path__ + "static/media/HomeSelected.3f5045cd.svg";